module.exports = __webpack_public_path__ + "img/logo-nintendo-switch.cfdbbcdc.svg";